/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

export enum TextParserComparisonOperator {
  ValueEqualTo = 0,
  ValueNotEqualTo = 1,
  ValueStartWith = 2,
  ValueEndWith = 3,
  ValueContain = 4,
  ValueLessThan = 5,
  ValueGreaterThan = 6
}
